"use client";

import { useLayoutEffect, useRef, useState } from "react";

import type { MissionHeatmapTooltipContent } from "./missionHeatmapDisplay";
import {
  resolveMissionHeatmapTooltipPosition,
  type MissionHeatmapTooltipPlacement,
} from "./missionHeatmapTooltipPosition";

export type ProfileMissionExperienceTooltipProps = Readonly<{
  anchorX: number;
  anchorY: number;
  content: MissionHeatmapTooltipContent;
}>;

type TooltipPositionState = Readonly<{
  left: number;
  top: number;
  placement: MissionHeatmapTooltipPlacement;
}>;

export function ProfileMissionExperienceTooltip({
  anchorX,
  anchorY,
  content,
}: ProfileMissionExperienceTooltipProps) {
  const tooltipRef = useRef<HTMLDivElement | null>(null);
  const [position, setPosition] = useState<TooltipPositionState>({
    left: anchorX,
    top: anchorY,
    placement: "above",
  });

  useLayoutEffect(() => {
    const tooltip = tooltipRef.current;
    const container = tooltip?.offsetParent instanceof HTMLElement ? tooltip.offsetParent : null;
    if (!tooltip || !container) {
      return;
    }

    setPosition(resolveMissionHeatmapTooltipPosition({
      anchorX,
      anchorY,
      containerWidth: container.clientWidth,
      containerHeight: container.clientHeight,
      tooltipWidth: tooltip.offsetWidth,
      tooltipHeight: tooltip.offsetHeight,
    }));
  }, [anchorX, anchorY, content.marketLabel, content.missionCountLabel, content.percentileLabel, content.portfolioPercentageLabel]);

  return (
    <div
      ref={tooltipRef}
      className="profile-mission-experience-tooltip"
      data-placement={position.placement}
      style={{
        left: `${position.left}px`,
        top: `${position.top}px`,
      }}
    >
      <strong>{content.marketLabel}</strong>
      <span>{content.missionCountLabel}</span>
      <span>{content.percentileLabel}</span>
      <span>{content.portfolioPercentageLabel}</span>
    </div>
  );
}
